import { useCallback } from 'react';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import removeCorporateFilterTag from './removeCorporateFilterTag';
import { endParentsIssuersExcludeWhenEmpty } from './endParentsIssuersExcludeWhenEmpty';

const PARENTS_ISSUERS_EXCLUDE_KEYS = ['excludedIssuerIds', 'excludedParentIds'];

const useTagRemove = (): ((tagKey: string) => void) => {
  const { setLocalFilters, getDraft, resetTo } = useCorporateBondScreenerSidebarFilterContext();

  return useCallback((tagKey: string): void => {
    removeCorporateFilterTag(tagKey, setLocalFilters);

    // exclude mode ends, and HoldCo/OpCo flip back, only when the last excluded issuer or parent is removed
    if (PARENTS_ISSUERS_EXCLUDE_KEYS.includes(tagKey)) {
      setLocalFilters(endParentsIssuersExcludeWhenEmpty);
    }

    resetTo(getDraft());
  }, [setLocalFilters, getDraft, resetTo]);
};

export default useTagRemove;
